import { useMutation, gql } from "@apollo/client"
import { ADMINABLE_USERS_FIELDS } from "./useQueryAdminableUsers"

const CREATE_EXTERNAL_USER_MUTATION = gql`
  ${ADMINABLE_USERS_FIELDS}
  mutation CreateExternalUser(
    $identityProvider: ID!
    $unique: String!
    $firstName: String!
    $lastName: String!
    $groups: [ID!]
    $locations: [ID!]!
    $roles: [String!]
  ) {
    createExternalUser(
      identityProvider: $identityProvider
      unique: $unique
      firstName: $firstName
      lastName: $lastName
      groups: $groups
      locations: $locations
      roles: $roles
    ) {
      ...AdminableUsersFields
    }
  }
`

const useMutationCreateExternalUser = () => useMutation(CREATE_EXTERNAL_USER_MUTATION)

export { useMutationCreateExternalUser }
